'use client';

import { c as _c } from "react/compiler-runtime";
import type { Profile } from '@channel.io/channel-web-sdk-loader';
import * as ChannelService from '@channel.io/channel-web-sdk-loader';
import { captureException } from '@sentry/nextjs';
import { usePathname } from 'next/navigation';
import { useEffect, useRef } from 'react';
import { useShallow } from 'zustand/react/shallow';
import { ENV } from '@/constants';
import { useAuthStore } from '@/stores/AuthStore';
import { toChannelBootError } from '@/utils/toChannelBootError';
import { isChannelTalkPath } from './channelTalkPath';
export const ChannelTalk = () => {
  const $ = _c(7);
  const pathname = usePathname();
  const [isLogin, myInfo] = useAuthStore(useShallow(_temp));
  const isMessengerVisibleRef = useRef(false);
  const isChannelLoadedRef = useRef(false);
  let t0;
  if ($[0] !== pathname) {
    t0 = isChannelTalkPath(pathname);
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isHiddenByPath = !t0;
  let t1;
  let t2;
  if ($[2] !== isHiddenByPath || $[3] !== isLogin || $[4] !== myInfo) {
    t1 = () => {
      const pluginKey = ENV.NEXT_PUBLIC_CHANNEL_TALK_PLUGIN_KEY;
      if (!pluginKey) {
        return;
      }
      if (isHiddenByPath) {
        return;
      }
      const toProfile = _temp5;
      const initChannelTalk = () => {
        ChannelService.loadScript();
        isChannelLoadedRef.current = true;
        ChannelService.boot({
          pluginKey,
          hideChannelButtonOnBoot: true,
          ...(isLogin && myInfo ? {
            ...(myInfo.memberOAuth !== undefined ? {
              memberId: myInfo.memberOAuth.toString()
            } : {}),
            profile: toProfile(myInfo as unknown as Record<string, unknown>)
          } : {})
        }, _temp6);
        ChannelService.onShowMessenger(() => {
          isMessengerVisibleRef.current = true;
        });
        ChannelService.onHideMessenger(() => {
          isMessengerVisibleRef.current = false;
        });
        ChannelService.onUrlClicked(() => {
          if (!isMessengerVisibleRef.current) {
            ChannelService.track("PopupBannerClick");
          }
        });
      };
      const idleCallbackId = typeof requestIdleCallback !== "undefined" ? requestIdleCallback(initChannelTalk, {
        timeout: 5000
      }) : undefined;
      const timeoutId = idleCallbackId === undefined ? setTimeout(initChannelTalk, 3000) : undefined;
      return () => {
        if (idleCallbackId !== undefined) {
          cancelIdleCallback(idleCallbackId);
        }
        if (timeoutId !== undefined) {
          clearTimeout(timeoutId);
        }
        if (isChannelLoadedRef.current) {
          ChannelService.clearCallbacks();
          ChannelService.shutdown();
          isChannelLoadedRef.current = false;
        }
      };
    };
    t2 = [isLogin, myInfo, isHiddenByPath];
    $[2] = isHiddenByPath;
    $[3] = isLogin;
    $[4] = myInfo;
    $[5] = t1;
    $[6] = t2;
  } else {
    t1 = $[5];
    t2 = $[6];
  }
  useEffect(t1, t2);
  return null;
};
function _temp(state) {
  return [state.isLogin, state.myInfo] as const;
}
function _temp2(v_0) {
  return typeof v_0 === "string";
}
function _temp3(v) {
  return typeof v === "number";
}
function _temp4(acc, t0) {
  const [key, value] = t0;
  if (value === undefined) {
    return acc;
  }
  if (value === null) {
    acc[key] = null;
    return acc;
  }
  const t = typeof value;
  if (t === "string" || t === "number" || t === "boolean") {
    acc[key] = value as string | number | boolean;
    return acc;
  }
  if (Array.isArray(value)) {
    if (value.every(_temp2)) {
      acc[key] = value as string[];
    } else {
      if (value.every(_temp3)) {
        acc[key] = value as number[];
      }
    }
  }
  return acc;
}
function _temp5(obj) {
  return Object.entries(obj).reduce(_temp4, {} as Profile);
}
function _temp6(error) {
  if (error) {
    captureException(toChannelBootError(error), {
      extra: {
        bootError: error
      }
    });
  }
}